import styled, { css } from "styled-components";
import { Card } from "react-bootstrap";

export const Container = styled(Card)`
  ${({ theme }) => css`
    margin-left: auto;
    margin-right: auto;
    margin-top: 9rem;
    width: 40%;
    height: 410px;
    border: 0;
    background-color: ${theme.colors.gstWhite};
    @media only screen and (max-width: 767px) {
      width: 90%;
    }
    @media only screen and (min-width: 768px) and (max-width: 1024px) {
      width: 70%;
    }
  `}
`;

export const CardHeader = styled.div`
  ${({ theme }) => css`
    text-align: center;
    font-weight: 600;
    margin-bottom: 0;
    background-color: ${theme.colors.gstBlue};
    color: ${theme.colors.gstWhite};
    padding: 0.85rem;
    font-size: 0.9rem;
    font-family: "Raleway", sans-serif;
  `}
`;

export const CardBody = styled.div`
  /* ... */
`;

export const CardFooter = styled.div`
  border: 0;
  padding: 0;
  padding-top: 5rem;
`;

export const Form = styled.form`
  padding: 5% 15%;
  @media only screen and (max-width: 767px) {
    padding: 5%;
  }
`;

export const FormLabel = styled.div`
  font-size: 20px;
  font-weight: 200;
  color: #6c757d;
  font-family: "Raleway", sans-serif;
`;

export const ButtonContianer = styled.div`
  text-align: center;
  margin-top: 30px;
  padding-bottom: 20px;
  @media only screen and (max-width: 767px) {
    margin-left: 0%;
  }
`;

export const RegisterWrap = styled.div`
  ${({ theme }) => css`
    position: relative;
    padding: 0 15%;
    bottom: 50px;
    display: flex;
    flex-flow: row;
    @media only screen and (max-width: 767px) {
      flex-flow: column;
      display: flex;
      flex-direction: column;
      padding: 0 5%;
    }
    a {
      font-size: 12px;
      color: ${theme.colors.lightGrey};
      text-transform: uppercase;
      cursor: pointer;
      font-weight: bold;
      margin-right: 30px;
      text-decoration: none;
      &:hover {
        color: ${theme.colors.hoverBlue};
        text-decoration: underline;
      }
    }
  `}
`;
